<template>
  <div class="get-hint" :class="newClass">
    <button class="btn btn-default btn-large" @click="requestSuggestion" v-if="!is_new">
      <span v-if="isHintLoading"> <i class="fa fa-spinner fa-spin"></i> Loading</span>
      <span v-else class="gradient-success">{{ __("New Hint") }}</span>
    </button>
    <div class="button-select" v-else>
      <button class="btn btn-default btn-large" @click="requestSuggestion" :disabled="isHintLoading">
        <span v-if="isHintLoading">LOADING</span>
        <span v-else class="gradient-success">{{ __("New Hint") }}</span>
      </button>

      <select v-model="language" style="max-width: 110px;" @change="requestSuggestion" v-if="is_new">
        <option value=''>Auto</option>
        <option value='af'>Afrikaans</option>
        <option value='am'>አማርኛ (Amharic)</option>
        <option value='ar'>العربية (Arabic)</option>
        <option value='bg'>български език (Bulgarian)</option>
        <option value='cs'>český (Czech)</option>
        <option value='nl'>Nederlands (Dutch)</option>
        <option value='en'>English</option>
        <option value='tl'>Filipino</option>
        <option value='fr'>Français (French)</option>
        <option value='de'>Deutch (German)</option>
        <option value='el'>Ελληνικά (Greek)</option>
        <option value='it'>Italiano (Italian)</option>
        <option value='pt'>Português (Portuguese)</option>
        <option value='es'>Español (Spanish)</option>
        <option value='sw'>Kiswahili (Swahili)</option>
        <option value='sv'>Svenska (Swedish)</option>
        <option value='tr'>Türkçe (Turkish)</option>
        <option value='ro'>Română (Romanian)</option>
        <option value='ru'>русский (Russian)</option>
        <option value='uk'>Українська (Ukrainian)</option>
      </select>
    </div>
  </div>
</template>

<script>

export default {
  props: ['review_id', 'team_id', 'is_new', 'is_changed', 'ignore_initial'],

  data() {
    return {};
  },
  data() {
    return {
      suggestions: [],
      isHintLoading: false,
      language: '',
    };
  },
  computed: {
    // Indicates whether or not the "Get Hint" button should be shown.
    newClass() {
      if (!this.is_new) return '';
      return 'd-flex align-items-center';
    },
  },
  mounted() {
    Vue.nextTick(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    Vue.directive('tooltip', function (el, binding) {
      $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover',
        html: true,
      });
    });
  },

  methods: {
    requestSuggestion() {
      if (this.ignore_initial) {
        this.$parent.$emit('expandSection');
        return;
      }
      this.getSuggestion();
    },

    getSuggestion() {
      this.$parent.$emit('hintLoading', true);
      this.isHintLoading = true;

      analytics.track('Clicked Hint', {
        review_id: this.review_id,
        team_id: this.team_id,
        repeat: this.is_new ? true : false,
      });

      axios
        .get(`/api/reviews/${this.team_id}/${this.review_id}/get-new-hint?lang=${this.language}`)
        .then((response) => {
          let hint = response.data;

          this.$parent.$emit('hintReady', hint);
          this.isHintLoading = false;
          if (this.language == 'ar') {
            this.$parent.$emit('setDirection', 'rtl');
          } else {
            this.$parent.$emit('setDirection', 'ltr');
          }

          analytics.track('Received Hint', {
            review_id: this.review_id,
            team_id: this.team_id,
            hint_id: hint.id,
          });
        });
    },
  },
}
</script>